<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="700">
      <v-form ref="AddFieldRef" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action == "Add" ? "Create New" : "Update" }} Field</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 900px" class="">
            <v-container class="pa-5">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="field_name"
                    :rules="[formRules.required]"
                    label="Label"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="field_type"
                    dense
                    label="Type of Input Field"
                    class="rounded-lg"
                    item-value="description"
                    item-title="description"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                    :items="field_type_list"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <div
                    class="pa-2 rounded-lg border border-1"
                    v-if="field_type && allowedArr.includes(field_type)"
                  >
                    <div
                      v-if="allowedArr.includes(field_type)"
                      class="d-flex justify-space-between align-center my-2"
                    >
                      <div class="text-subtitle-1">Options</div>
                      <v-btn
                        :color="$vuetify.theme.themes.light.submitBtnsGreen"
                        class="white--text"
                        size="small"
                        density="comfortable"
                        variant="flat"
                        @click="addOptions"
                      >
                        <v-icon>mdi-plus</v-icon>
                        Add
                      </v-btn>
                    </div>
                    <div
                      class="my-2 d-flex justify-space-between align-center"
                      v-for="(i, idx) in field_options"
                      :key="idx"
                    >
                      <v-text-field
                        hide-details
                        v-model="i.option_name"
                        :rules="[formRules.required]"
                        :label="`Option ${idx + 1}`"
                        :color="$vuetify.theme.themes.light.inputColor"
                        variant="outlined"
                        density="compact"
                      ></v-text-field>

                      <div class="mx-2">
                        <v-btn
                          hide-details
                          color="red"
                          class="white--text"
                          size="x-small"
                          icon
                          @click="removeOption(idx)"
                        >
                          <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              {{ action == "Add" ? "Add" : "Update" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      btnLoading: false,
      dialog: false,
      field_name: null,
      field_type: null,
      field_options: [],
      field_type_list: ["Radio Button", "Dropdown", "Textfield", "Textarea"],
      allowedArr: ["Radio Button", "Dropdown"],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      fileLoaded: false,
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log(data);
        this.initialize();
        this.$refs.AddFieldRef.resetValidation();
        if (data.id) {
          this.field_name = data.field_name;
          this.field_type = data.field_type;
          this.field_options = data.field_options ? data.field_options : [];
        } else {
          this.$refs.AddFieldRef.reset();
          this.$refs.AddFieldRef.resetValidation();
        }
      },
      deep: true,
    },
  },
  computed: {},
  methods: {
    initialize() {},

    async save() {
      let formValid = await this.$refs.AddFieldRef.validate();

      if (formValid.valid) {
        this.axiosCall("/student/add-batch-field", "POST", {
          field_name: this.field_name,
          student_batch_id: this.data.student_batch_id,
          field_type: this.field_type,
          field_options: this.allowedArr.includes(this.field_type)
            ? JSON.stringify(this.field_options)
            : JSON.stringify([]),
        }).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    async update() {
      let formValid = await this.$refs.AddFieldRef.validate();

      if (formValid.valid) {
        this.axiosCall("/student/update-batch-field", "POST", {
          id: this.data.id,
          field_name: this.field_name,
          field_type: this.field_type,
          field_options: this.allowedArr.includes(this.field_type)
            ? JSON.stringify(this.field_options)
            : JSON.stringify([]),
        }).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    addOptions() {
      this.field_options.push({
        option_name: "Option",
      });
    },

    removeOption(index) {
      this.field_options.splice(index, 1);
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.program_id;
      this.initialize();
    },

    async save_file() {
      let valid = await this.$refs.addFileRef.validate();
      if (valid.valid) {
        this.addFileDialog = false;
      }
    },

    closeD() {
      eventBus.emit("closeAddProfilingFieldDialog", true);
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
